import {useCallback, useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import SetTicketLabelsMutation from '../../../../../mutations/ticketing/tickets/setTicketLabelsMutation';

interface Options {
	onCompleted?: () => void;
	onError?: (error: Error) => void;
}

export function useSetTicketLabels(options?: Options) {
	const [inFlight, setInFlight] = useState(false);

	const setLabels = useCallback(
		(ticketId: string, labelIds: string[]) => {
			setInFlight(true);
			commitTicketingMutation(
				SetTicketLabelsMutation,
				{ticketId, labelIds},
				() => {
					setInFlight(false);
					options?.onCompleted?.();
				},
				error => {
					setInFlight(false);
					options?.onError?.(error instanceof Error ? error : new Error(String(error)));
				}
			);
		},
		[options]
	);

	return {setLabels, inFlight};
}
